<template>
  <div id="events_container" :class="getContainerClass()">
    <div v-show="isShowLoadingIcon" class="loading_spinner_wrapper">
      <img :src="contentCloudFrontWithVersion('/ellipsis.svg')">
    </div>
    <avgl-events v-if="appConfig.isAvglDomain" :events="events" />
    <boom-events v-else :events="events" />
  </div>
</template>

<script>
import { component } from '../../../../mixins/component';
import BoomEvents from './boom';
import AvglEvents from './avgl';
import { ConfigMixin } from '../../../../mixins/config';
import { TimeHelper } from '../../../../mixins/time';

const BOOMTV_LANDING_EVENT_CATEGORIES = ['featured', 'creator', 'highschool'];
const AVGL_LANDING_EVENT_CATEGORIES = ['featured', 'college', 'high-school', 'community'];

export default {
  components: { BoomEvents, AvglEvents },
  mixins: [component, ConfigMixin, TimeHelper],
  props: {
    type: {
      type: String,
      default: 'events',
    },
  },
  data() {
    return {
      displayCategories: [],
      events: {
        featured: {},
        creator: {},
        highschool: {},
      },
      isShowLoadingIcon: true,
    };
  },
  created() {
    if (!this.appConfig.isAvglDomain) {
      this.displayCategories = BOOMTV_LANDING_EVENT_CATEGORIES;
    } else {
      this.displayCategories = AVGL_LANDING_EVENT_CATEGORIES;
    }
    this.displayCategories.map(category => {
      this.events[category] = {};
    });
  },
  mounted() {
    this.getListEvents('landing');
  },
  methods: {
    getContainerClass() {
      if (this.type === 'landing') {
        if (this.appConfig.isAvglDomain) {
          return 'avgl_landing_page_wrap event_page_wrap';
        } else {
          return 'landing_page_wrap event_page_wrap';
        }
      }
      return 'event_page_wrap';
    },
    async getListEvents(category) {
      const timezone = encodeURIComponent(this.guessTimezone());
      const url = this.routeFilterEventV2() + '&category=' + category +
                    '&limit=' + this.LIMIT_DEFAULT_SLICK_EVENT + '&see_all=' + 0 + '&timezone=' + timezone;

      if (category === 'landing') {
        this.displayCategories.map(category => {
          this.events[category] = {};
          this.events[category].url = this.routeFilterEventV2() + '&category=' + category +
                            '&timezone=' + timezone;
        });
      } else {
        this.events[category] = {};
        this.events[category].url = url;
      }

      this.isShowLoadingIcon = true;

      try {
        const res = await this.$http.get(url);
        const data = this.changeDataEventTimezone(res.data);
        if (category === 'landing') {
          this.displayCategories.map(category => {
            this.events[category] = {
              ...this.events[category],
              data: data[category],
            };
          });
        } else {
          this.events[category] = {
            ...this.events[category],
            data: data,
          };
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isShowLoadingIcon = false;
      }
    },
  },
};
</script>
